module.exports = __webpack_public_path__ + "static/media/boat-img-9.2d383189.jpg";